import { Skeleton } from '@mui/material';
import { type JSX } from 'react';

import { HorseshoeProgressIndicator } from 'Components/Indicator/HorseshoeProgressIndicator';
import { QuestionnaireAggregationResponse } from 'Models/TPRM';

import styles from './DDQQuestionsAnsweredGraph.module.css';

export interface DDQQuestionsAnsweredGraphProps {
    aggregationResponse: QuestionnaireAggregationResponse;
}

export const DDQQuestionsAnsweredGraph = (props: DDQQuestionsAnsweredGraphProps): JSX.Element => {
    const assessmentPercentComplete = props.aggregationResponse ? (props.aggregationResponse.number_of_questions_completed / props.aggregationResponse.number_of_questions) * 100 : undefined;

    return (
        <>
            {assessmentPercentComplete !== undefined ? (
                <div className={styles.progressBarContainer}>
                    <HorseshoeProgressIndicator fill={assessmentPercentComplete} text={`${props.aggregationResponse.number_of_questions_completed}/${props.aggregationResponse.number_of_questions}`} largeFont />
                </div>
            ) : (
                <div className={styles.services}>
                    <Skeleton sx={{ width: '250px', height: '250px' }} variant="circular" />
                </div>
            )}
        </>
    );
};
